import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { deleteUserMutation, getUsersListQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useDeleteUser = (page, limit) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [deleteUserAction, { loading }] = useMutation(
        deleteUserMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getUsersListQuery,
                    variables: {
                        limit,
                        page,
                    },
                },
            ],
        },
    );

    const { deleteUserPending: deleteUserPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const deleteUser = async (id) => {
        try {
            await deleteUserAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        `${t(
                            "messages.deleteMsgs.success",
                            { entity: t("users.entity") },
                        )}, ${t("messages.operationDelay")}`,
                        statusTypesData.success,
                    ));
                },
                variables: {
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${deleteUserPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.deleteMsgs.pending",
                        { entity: t("users.entity") },
                    ),
                    { toastId: `${deleteUserPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return { deleteUser };
};

export default useDeleteUser;
